import { useLayoutEffect } from "react"
import { UseFormReturn } from "react-hook-form"
import { useLens } from "@hookform/lenses"
import { useProgressNoteFormContext } from "@/modules/patients/detail/progress-note/hooks/useProgressNoteFormStore"
import { useStoreFormEffect } from "@/modules/patients/detail/progress-note/hooks/useStoreFormEffect"
import { StoreFormState } from "@/modules/patients/detail/progress-note/hooks/useStoreFormState"
import { PointOfCareFormType } from "@/modules/patients/detail/progress-note/point-of-care/schema"
import { EpisodeOfCareProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"

export const useProgressNotePointOfCareFormEffect = (
  episodeOfCareProgressNoteData: EpisodeOfCareProgressNoteData,
  storeFormState: StoreFormState,
  form: UseFormReturn<PointOfCareFormType>,
) => {
  const setProgressNoteForm = useProgressNoteFormContext((state) => state.setProgressNoteForm)

  const lens = useLens({ control: form.control })

  useStoreFormEffect(storeFormState, form, lens.focus("formIsDirty"))

  useLayoutEffect(() => {
    setProgressNoteForm(episodeOfCareProgressNoteData.id, episodeOfCareProgressNoteData, {
      kind: "PointOfCare",
      data: form,
    })
  }, [episodeOfCareProgressNoteData.id, episodeOfCareProgressNoteData, form, setProgressNoteForm])
}
